import type { AppContext } from "@/types/scheduling"
import { LeadEmailSchema, LeadNameSchema, LeadPhoneNumberSchema } from "shared/validations"
import { safeParse } from "valibot"

export const handleValidNext = <T extends AppContext>(context: T, params: { key: string }) => {
  if (params.key === "insurance_provider_other") {
    return !!context.result.insurance_provider_other && context.result.insurance_provider_other !== "" &&
      context.result.insurance_provider_other?.length > 1
  }
  if (params.key === "lead_name") {
    const result = safeParse(LeadNameSchema, context.result.lead_name)
    return result.success
  }
  if (params.key === "lead_email") {
    const result = safeParse(LeadEmailSchema, context.result.lead_email)
    return result.success
  }
  if (params.key === "lead_phone_number") {
    const result = safeParse(LeadPhoneNumberSchema, context.result.lead_phone_number)
    return result.success
  }
  return false;
}